// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navbar {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.0625);\n  padding: 0.4rem 1rem;\n}\n.navbar .extranet-title {\n  margin-left: 2rem;\n  font-size: 1.2rem;\n}", ""]);
// Exports
module.exports = exports;
